export const createIpoRoute = ({param, name}) =>
  `/dashboard/asset-management/create/ipo/${param}/${name || ''}`;

export const createIpoStepTwoRoute = ({param, name}) =>
  `/dashboard/asset-management/create/ipo/${param}/step-two/${name || ''}`;

export const createEquityRoute = ({param, name}) =>
  `/dashboard/asset-management/create/public-equity/${param}/${name || ''}`;

export const createEquityStepTwoRoute = ({param, name}) =>
  `/dashboard/asset-management/create/public-equity/${param}/step-two/${
    name || ''
  }`;
